// extracted by mini-css-extract-plugin
export default {"container":"style_container__s7H8f","icon":"style_icon__4MDz6"};